import Rubrique from "./Rubrique";
export default Rubrique;
